import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";
import { getMissingCountries } from "../fields/AddressField/utils";

export function requestedInternationalAddressesRule(
  rule: components["schemas"]["RequestedInternationalAddressesRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      addresses: components["schemas"]["AddressesCheckField"]["value"]
    ) => {
      const missingCountries = getMissingCountries(addresses, rule.value ?? []);

      return missingCountries.length === 0;
    },
  };
}
